import { useState } from "react";
import { act, post } from "../lib/api";
import { dayLabel } from "../lib/time";
import { Sheet } from "./bits";
import { EstimatePicker } from "./EstimatePicker";

export function LeaveSheet({ rows, person, today, onClose, onDone }) {
  const [f, setF] = useState({ person: person || rows[0]?.person.id, from: today, to: today, note: "" });
  const [err, setErr] = useState(null);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });
  async function save() {
    const r = await post("/leaves", f);
    if (!r.ok) return setErr(r.error.message);
    await act(Promise.resolve(r));
    onDone();
  }
  return (
    <Sheet title="Mark on leave" onClose={onClose} testid="leave-sheet">
      <label className="fld-lbl">Who</label>
      <select className="fld" value={f.person} onChange={set("person")} data-testid="leave-person">
        {rows.map((r) => <option key={r.person.id} value={r.person.id}>{r.person.name}</option>)}
      </select>
      <div className="two">
        <div><label className="fld-lbl">From</label><input className="fld" type="date" value={f.from} onChange={set("from")} data-testid="leave-from" /></div>
        <div><label className="fld-lbl">Till</label><input className="fld" type="date" value={f.to} onChange={set("to")} data-testid="leave-to" /></div>
      </div>
      <label className="fld-lbl">Note (optional)</label>
      <input className="fld" value={f.note} maxLength={140} onChange={set("note")} data-testid="leave-note" />
      {err && <p className="err" data-testid="leave-error">{err}</p>}
      <button className="btn-primary" onClick={save} data-testid="leave-save">Save dates</button>
    </Sheet>
  );
}

export function NewCardSheet({ me, rows, clients, date, person, onClose, onDone }) {
  const canAssign = me.caps.plan;
  const [f, setF] = useState({ client: "", title: "", assignee: canAssign ? person || "" : "", est: { kind: "hours", hours: 2 }, kind: "new" });
  const [err, setErr] = useState(null);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });
  const title = date === me.today ? "Add work for today" : date === me.tomorrow ? "Add work for tomorrow" : `Add work for ${dayLabel(date)}`;
  async function save() {
    if (!f.client) return setErr("Pick a client.");
    if (!f.title.trim()) return setErr("What needs doing?");
    if (!f.est) return setErr("Pick an estimate.");
    const r = await post("/tasks", { date, client: f.client, title: f.title.trim(), assignee: f.assignee || null, kind: f.kind, estimate: f.est });
    if (!r.ok) return setErr(r.error.message);
    await act(Promise.resolve(r));
    onDone();
  }
  return (
    <Sheet title={title} onClose={onClose} testid="new-card-sheet" width={520}>
      <label className="fld-lbl">Client</label>
      <select className="fld" value={f.client} onChange={set("client")} data-testid="new-card-client">
        <option value="">Pick a client</option>
        {clients.map((c) => <option key={c.code} value={c.code}>{c.name}</option>)}
      </select>
      {canAssign ? <>
        <label className="fld-lbl">Put it on</label>
        <select className="fld" value={f.assignee} onChange={set("assignee")} data-testid="new-card-assignee">
          <option value="">The request tray (decide later)</option>
          {rows.map((r) => <option key={r.person.id} value={r.person.id} disabled={!!r.away}>
            {r.person.name}, {r.person.designation}{r.away ? (r.away.roster ? " (not in that day)" : " (on leave)") : ""}</option>)}
        </select></> : <p className="lock-note" data-testid="new-card-tray-note">It goes to the request tray. The planners put it on someone's list.</p>}
      <label className="fld-lbl">What needs doing</label>
      <input className="fld" value={f.title} placeholder="e.g. Diwali carousel x5" onChange={set("title")} data-testid="new-card-title" />
      <label className="fld-lbl">Estimate</label>
      <EstimatePicker testid="new-card-est" initial="2" onPick={(est) => setF((x) => ({ ...x, est }))} />
      <label className="fld-lbl">Kind</label>
      <div className="chips">{[["new", "New"], ["revision", "Revision"], ["adapt", "Adapt"]].map(([v, l]) => <button key={v} type="button" aria-pressed={f.kind === v}
        className={`chip-btn ${f.kind === v ? "on" : ""}`} onClick={() => setF({ ...f, kind: v })} data-testid={`new-card-kind-${v}`}>{l}</button>)}</div>
      {err && <p className="err" role="alert" data-testid="new-card-error">{err}</p>}
      <button className="btn-primary" onClick={save} data-testid="new-card-save">{f.assignee ? "Add to their list" : "Add to tray"}</button>
    </Sheet>
  );
}
